import {
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfYear,
  endOfYear,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns'

const formatDate = (date: Date) => format(date, 'yyyyMMdd')

export interface DateDropDownItem {
  start: string
  end: string
  label: string
  value: string
}

export const getDateRanges = () => {
  const now = new Date()

  const currentMonth = {
    start: formatDate(startOfMonth(now)),
    end: formatDate(endOfMonth(now)),
    label: 'Mês Atual',
    value: 'currentMonth',
  }

  const lastMonth = {
    start: formatDate(startOfMonth(subMonths(now, 1))),
    end: formatDate(endOfMonth(subMonths(now, 1))),
    label: 'Mês Anterior',
    value: 'lastMonth',
  }

  const lastTrimester = {
    start: formatDate(startOfDay(subMonths(now, 3))),
    end: formatDate(endOfDay(now)),
    label: 'Últimos 3 meses',
    value: 'lastTrimester',
  }

  const currentYear = {
    start: formatDate(startOfYear(now)),
    end: formatDate(endOfYear(now)),
    label: 'Ano Atual',
    value: 'currentYear',
  }

  const lastYearDate = subMonths(startOfYear(now), 1)
  const lastYear = {
    start: formatDate(startOfYear(lastYearDate)),
    end: formatDate(endOfYear(lastYearDate)),
    label: 'Ano Anterior',
    value: 'lastYear',
  }

  return {
    currentMonth,
    lastMonth,
    lastTrimester,
    currentYear,
    lastYear,
  }
}
